module.exports = __webpack_public_path__ + "static/media/kiosk_bck.75e15e12.png";